export default __webpack_public_path__ + "static/nric-back-7121a38e2f791f1bdb80729d877018ba.png";